import React, { useState, useEffect, useContext } from 'react';
import { faInfoCircle, faSearch, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, CardHeader, Input, InputGroup, InputGroupText, Popover, PopoverBody } from 'reactstrap';
import style from './Groups.style';

// import FocustItems from './FocusItems/FocustItems';
import { clone } from '../../../../../Services/schedule';
import GroupItem from './GroupItem/GroupItem';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { deleteData, fetchDataAgnostic, postDataAgnostic, putData } from '../../../../../Services/dataApi';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { DepartmentContext } from 'DepartmentWrapper';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const Groups = ({ allowEdit = false, windowWidth }) => {
  const [newGroup, setNewGroup] = useState({ name: '' }); // DocumentTypeName, UIIcon
  const [groupChoices, setGroupChoices] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showAboutGroupsPopover, setShowAboutGroupsPopover] = useState(false);
  const isMobileView = windowWidth < 980;

  const { getTokenSilently, loginWithRedirect } = useAuth0();

  const dContext = useContext(DepartmentContext);

  useEffect(() => {
    getGroups();
  }, []);

  const getGroups = () => {
    setIsLoading(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'candidate/groups',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          formatBearerToken(token),
        )
          .then((res) => {
            setGroupChoices(res.data);
            setIsLoading(false);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const filterTags = (groupChoices) => {
    const newFilters = { ...groupChoices };
    Object.keys(groupChoices).forEach((key) => {
      const tag = groupChoices[key];
      if (tag.Tag.toLowerCase().indexOf(searchString.toLowerCase()) < 0) {
        delete newFilters[key];
      }
    });
    return newFilters;
  };

  const addNewGroup = (newGroup, promiseDetails) => {
    setIsLoading(true);
    getTokenSilently()
      .then((token) => {
        postDataAgnostic(
          'candidate/group',
          null,
          {
            Name: newGroup,
            Description: '',
            fk_Department: dContext.department.pk_Department,
            fk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            toast.success('Group added successfully');
            setIsLoading(false);
            if (promiseDetails) {
              const { resolve } = promiseDetails;
              resolve('true');
            } else {
            }
          })
          .catch((err) => {
            toast.error('Error adding group');
            setIsLoading(false);
            if (promiseDetails) {
              const { reject } = promiseDetails;
              reject();
            }
          })
          .finally(() => {
            getGroups();
          });
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error('Error adding group');
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const onSave = (Group) => {
    const newGroupChoices = JSON.parse(JSON.stringify(groupChoices));
    newGroupChoices[Group.index] = Group;
    setGroupChoices(newGroupChoices);
    // updateTags(tag);
  };

  const filteredGroupChoices = groupChoices
    .sort((a, b) => {
      if (!a.Name) {
        return -1;
      }

      if (!b.Name) {
        return 1;
      }
      const result = a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0;

      return result;
    })
    .filter((Group) => {
      if (Group.Name) {
        return Group.Name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0;
      }
    });

  const hasSearchValues = filteredGroupChoices.length > 0;

  useEffect(() => {
    if (!isMobileView && showAboutGroupsPopover) {
      setShowAboutGroupsPopover(false);
    }
  }, [isMobileView, showAboutGroupsPopover]);

  const renderAboutGroupsContent = (isMobile = false) => {
    return (
      <>
        <div style={isMobile ? style.aboutGroupsTitleMobile : style.aboutGroupsTitle}>About Groups</div>
        <ul style={isMobile ? style.aboutGroupsListMobile : style.aboutGroupsList}>
          <li>Unlike tags, candidates can only belong to one group at a time.</li>
          <li>
            Groups are utilized in Mock Oral Board reports to provide scoring compared to other members of the same
            group.
          </li>
        </ul>
      </>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={style.mainContainer}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: isMobileView ? '100%' : '60%',
              flex: isMobileView ? '1 1 100%' : '0 0 60%',
            }}
          >
            <Card
              style={{
                ...style.groupCard,
                minWidth: isMobileView ? 'unset' : style.groupCard.minWidth,
                width: '100%',
                height: 'auto',
              }}
            >
            <CardHeader>
              <div style={style.groupHeaderRow}>
                <div style={style.centeredText}>
                  <b>Groups</b>
                </div>
                {isMobileView ? (
                  <Button
                    id="aboutGroupsMobileBtn"
                    size="sm"
                    color="secondary"
                    style={style.aboutInfoButton}
                    onClick={() => {
                      setShowAboutGroupsPopover((prev) => !prev);
                    }}
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                  </Button>
                ) : null}
              </div>
            </CardHeader>
            <CardBody>
            <InputGroup>
              <InputGroupText>
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{ ...style.clickable }}
                  onClick={() => {
                    setSearchString('');
                  }}
                />
              </InputGroupText>

              <Input
                value={searchString}
                type="text"
                placeholder="Search Groups. . ."
                onChange={(e) => {
                  setSearchString(e.target.value);
                }}
              />
              <InputGroupText>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroupText>
            </InputGroup>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginRight: '20px',
              }}
            >
              <div
                style={{
                  alignSelf: 'flex-end',
                  padding: '5px',
                  verticalAlign: 'bottom',
                  width: '100px',
                }}
              >
                <strong> Groups</strong>
              </div>
              <div clasnName="editAndTagWrappper" style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                  style={{
                    alignSelf: 'flex-end',
                    marginLeft: '3px',
                    padding: '5px',
                    textAlign: 'center',
                    verticalAlign: 'bottom',
                    width: '45px',
                  }}
                >
                  <strong>Edit</strong>
                </div>
                <div
                  style={{
                    alignSelf: 'flex-end',
                    marginLeft: '3px',
                    padding: '5px',
                    textAlign: 'center',
                    verticalAlign: 'bottom',
                    width: '60px',
                  }}
                >
                  <strong>Delete </strong>
                </div>
              </div>
            </div>
            <div style={{ overflowY: 'scroll', height: '30vh' }}>
              {filteredGroupChoices && filteredGroupChoices.length > 0 ? (
                filteredGroupChoices.map((Group, i) => {
                  return <GroupItem Group={Group} index={i} onSave={onSave} getGroups={getGroups} />;
                })
              ) : !isLoading ? (
                <div style={style.centeredText}>No Groups</div>
              ) : (
                <div style={style.centeredText}>Loading. . .</div>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 10,
              }}
            >
              <Button
                color="success"
                onClick={() => {
                  Swal.fire({
                    title: 'Add New Group',
                    input: 'text',
                    inputAttributes: {
                      autocapitalize: 'off',
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Add',
                    showLoaderOnConfirm: true,
                    preConfirm: (newGroup) => {
                      return new Promise((resolve, reject) => {
                        addNewGroup(newGroup, { resolve, reject });
                      });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                  });
                }}
              >
                Add New Group <FontAwesomeIcon icon={faPlus} />
              </Button>
            </div>
            </CardBody>
            </Card>
          </div>
          {!isMobileView ? (
            <div
              style={{
                ...style.aboutGroupsPanel,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '40%',
                flex: '0 0 40%',
              }}
            >
              {renderAboutGroupsContent(false)}
            </div>
          ) : null}
        </div>

        {isMobileView ? (
          <Popover
            placement="bottom-end"
            isOpen={showAboutGroupsPopover}
            target="aboutGroupsMobileBtn"
            toggle={() => {
              setShowAboutGroupsPopover((prev) => !prev);
            }}
          >
            <PopoverBody>{renderAboutGroupsContent(true)}</PopoverBody>
          </Popover>
        ) : null}
      </div>
    </div>
  );
};

export default Groups;
